import { ButtonType, DialogFooterButtonsWidget, TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { formatDate } from '../utils/CredentialEncrpytionUtils';


export interface KMSKeyGenerateForbiddenViewProps {
    closeDialog: CloseAndDismiss;
    nextRotationDate: string;
    coolDownPeriod: number;
}

export interface KMSKeyGenerateForbiddenViewState {
}

export class KMSKeyGenerateForbiddenView extends React.PureComponent<KMSKeyGenerateForbiddenViewProps, KMSKeyGenerateForbiddenViewState> {

    constructor(props: KMSKeyGenerateForbiddenViewProps) {
        super(props);
    }


    public render(): JSX.Element {
        return <>
            <div>
                {Messages.credentialEncryption_KMSKeyGenerateForbidden_Description({COOLDOWN: this.props.coolDownPeriod.toString(), DATETIME: formatDate(this.props.nextRotationDate)})}
                <span>
                    <TextLinkWidget
                        testId={'online-kms-creds-generate-learn-more'}
                        target={'_blank'}
                        href={HelpService.getHelpUrlByCategory('online-kms-creds-generate')}
                        className={learnMoreStyle}>
                        {Messages.learnMore()}
                    </TextLinkWidget>
                </span>
            </div>
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        }
                    ]}
                />
            </div>
        </>;
    }
}
